import { CardType } from "../Prototype/Level/Card/CardType";

export enum WinCriteriaType {
    CLEAR_ALL = 'clear_all',
    CLEAR_GOLD = 'clear_gold',
}

type tWinCriteriaType = {
    [winCriteriaType in WinCriteriaType]: {
        textKey: string;
        texture: string;
        isObjectiveCard: (type: CardType, value: number) => boolean;
    };
};

export const WinCriteriaTypeMap: tWinCriteriaType = {
    [WinCriteriaType.CLEAR_ALL]: {
        textKey: 'ClearAllCards',
        texture: 'goals_clear_all',
        isObjectiveCard: () => true,
    },
    [WinCriteriaType.CLEAR_GOLD]: {
        textKey: 'FindGoldCards',
        texture: 'goals_clear_gold',
        isObjectiveCard: (type) => type === CardType.gold,
    },
};
